module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationa"
  }, [_c('span', [_c('i', [_vm._v("Dedicated to the organic pioneers who have paved the way before us. With deep gratitude")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationb"
  }, [_c('span', [_c('i', [_vm._v("And to young agrarians who are now changing the face of agriculture. We have not only the choice to do things differently, but the means as well")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "image0"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "65",
      "src": "Images/fviii-01.jpg",
      "width": "59"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f6ee3d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 72
// module chunks = 0